import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

/**
 * Pass multiple buttons with text and icon to the dialog
 */

function ActionButtonDialog(props) {
  const {
    open,
    setOpen,
    dialogTitle,
    dialogContentText,
    buttons,
    selectedButtonId = -1,
  } = props;
  const handleClose = () => {
    setOpen((prev) => ({ ...prev, open: false }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="create-dialog"
      maxWidth="sm"
    >
      <DialogTitle style={{ paddingBottom: 0 }}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Typography>{dialogContentText} </Typography>
        <List>
          {buttons.map((btn) => (
            <ListItem
              button
              key={btn.id}
              onClick={btn.onClick}
              selected={btn.id === selectedButtonId}
              sx={{ borderRadius: 2 }}
            >
              <ListItemIcon>{btn.icon}</ListItemIcon>
              <ListItemText
                primary={btn.primaryText}
                secondary={btn?.secondaryText ?? ""}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default ActionButtonDialog;
